import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { useCountdown } from '../hooks/useCountdown';
import { offer } from '../data/offer';
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown(23.75);
  return <section id="offer" aria-labelledby="offer-heading" className="bg-navy-950" data-id="element-47" data-mp="15ckjkv8vocby">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "30px",
      paddingBottom: "30px"
    }} data-id="element-48" data-mp="1jcd58c5js2d2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="1ebxvdukh5czu">
          <h2 id="offer-heading" className="font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl" data-id="element-50" data-mp="1t1wpnm8ws4a1">
            এমন ২,৮৪৭ জনেরও বেশি উচ্চাকাঙ্ক্ষী তরুণ বাংলাদেশির দলে যোগ দিন, যারা ইতিমধ্যেই নিজেদের জীবন বদলে ফেলছেন।
          </h2>
          

          <div className="mt-10 flex flex-wrap items-baseline justify-center gap-x-4 gap-y-2" data-id="element-51" data-mp="1x51pfh1ltruz">
            <span className="font-display text-5xl font-extrabold tabular-nums text-white" data-id="element-52" data-mp="n649jisb5ija">
              {offer.priceToday}
            </span>
            <span className="text-xl text-white/40 line-through" data-id="element-53" data-mp="s57e724dlmqq">
              {offer.priceTomorrow}
            </span>
            <span className="text-sm text-celeste-300" data-id="element-54" data-mp="x64xxj51aouc">
              একবারের পেমেন্ট · ৬টি ভলিউম + ৫টি বোনাস · লাইফটাইম অ্যাক্সেস — ১০০% সিকিউর চেকআউট — সাথে সাথেই ডিজিটাল ডাউনলোড
            </span>
          </div>

          <div className="mt-8 flex flex-col items-center" data-id="element-55" data-mp="1b3jowsaxr4of">
            <CtaButton size="lg" href={offer.checkoutUrl} note="ইবুকগুলো ইংরেজি ভাষায় লেখা" label={<>হ্যাঁ! আমি দ্য আর্জেন্টাইন মাইন্ডসেট চাই 🏆 মাত্র <span className="text-[1.35em] font-extrabold" data-id="element-57" data-mp="1kt3bo91rriok">9</span> USD-তে (প্রায় 1,050 BDT)</>} sublabel={`সাথে সাথেই অ্যাক্সেস · ৭ দিনের গ্যারান্টি · ${offer.studentCount} শিক্ষার্থীর সাথে যোগ দিন`} data-id="element-56" data-mp="1b1qjfgc26qi0" />
          </div>

          <div className="mx-auto mt-10 max-w-xl rounded-xl border border-white/10 bg-navy-900 px-6 py-5" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-58" data-mp="1tt9lnky9e0iz">
            <p className="flex flex-wrap items-center justify-center gap-2 text-sm text-white/75" data-id="element-59" data-mp="3lw46pmtnzodm">
              <ClockIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-60" data-mp="3i4oorhfv8s8" />
              {expired ? <span data-id="element-61" data-mp="3uwad6oqy3o3a">
                  এই বিশেষ মূল্য শেষ হচ্ছে{' '}
                  <span className="font-semibold text-white" data-id="element-62" data-mp="3uu62nnyjjqu1">আজই</span>
                </span> : <>
                  এই বিশেষ মূল্য শেষ হচ্ছে
                  <span className="font-display font-bold tabular-nums text-white" data-id="element-63" data-mp="8h7l5njcs6ol">
                    {hours}:{minutes}:{seconds}
                  </span>
                  পরে
                </>}
            </p>
            <p className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50" data-id="element-64" data-mp="iem01ipmones">
              <span className="flex items-center gap-1.5" data-id="element-65" data-mp="2o8lmnfujyzub">
                <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="2k6ib6r7vvv91" />
                ১০০% সিকিউর পেমেন্ট
              </span>
              <span className="flex items-center gap-1.5" data-id="element-67" data-mp="2a3d1g4bbnxzi">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="2e3vproe0alwy" />
                আপনার তথ্য সুরক্ষিত
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}